import { AppFontSize } from '../enums/app-font-size.enum';

export function formatFontSizeClassName(fontSize: AppFontSize): string {
  return `${fontSize}-font-size`;
}
